document.addEventListener('copy', function(e) {
  const extraText = "";
  
  const selection = window.getSelection().toString();
  if (selection.length > 0) {    
    const copiedText = window.extraCopyTextFromSettings + " " + selection;    
    e.clipboardData.setData('text/plain', copiedText);    
    e.preventDefault();
  }
});